export { default } from './InputController'
